module.exports = __webpack_public_path__ + "img/Nahima.8b95ff50.jpg";